<template>
  <vue-signature-pad ref="signaturePad"/>
  <div class="__center">
    <btn :txt="'초기화'"
         :color="'gray'"
         :size="'middle'"
         @click="btnClear_click"/>
    <btn :txt="'완료'"
         :color="'purple'"
         :size="'middle'"
         @click="btnCompt_click"/>
  </div>
</template>

<script setup>
import {VueSignaturePad} from "vue-signature-pad";

import {defineEmits, ref} from 'vue';

import {getUtils} from "@/utils/import";
const {$alert} = getUtils();

const emits = defineEmits(['compt', 'close'])

const signaturePad = ref(null);
const btnClear_click = () => {
  signaturePad.value.clearSignature();
}

const btnCompt_click = async () => {
  const { isEmpty, data } = signaturePad.value.saveSignature();
  if (isEmpty) {
    await $alert('서명을 해주세요.');
    return false;
  }

  emits('compt', data);
  emits('close');
}
</script>

<style scoped>

</style>